import { message } from 'antd'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { DEFAULT_MESSAGE_DURATION } from 'consts/appConsts'

import './GeneralMessage.css'

export const GeneralMessage = () => {
  const [messageApi, contextHolder] = message.useMessage()
  const messageConfig = useSelector(state => state.app.messageConfig)
  useEffect(() => {
    if (messageConfig) {
      messageApi.open({
        type: messageConfig.type,
        content: messageConfig.content,
        duration: messageConfig?.duration || DEFAULT_MESSAGE_DURATION,
        icon:
          messageConfig.type === 'success' ? <i className='icon-check' /> : null
      })
    }
  }, [messageConfig, messageApi])

  return <>{contextHolder}</>
}

export default GeneralMessage
